import { CmsObjectWithDefault } from '@components/Cms/types';

export type EmailLoginFormContainerCmsKey = 'emailFormatError' | 'passwordTooShortError';
export const EmailLoginFormContainerCmsWithDefault: CmsObjectWithDefault<EmailLoginFormContainerCmsKey> = {
    emailFormatError: {
        cmsId: 67546,
        defaultTranslation: 'Email Address format is not valid.',
    },
    passwordTooShortError: {
        cmsId: 102136,
        defaultTranslation: 'Password is case sensitive and must be at least 8 characters long.',
    },
};
